var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_vm._v("\n  "+_vm._s(_vm.testPackageSample.name)+": "+_vm._s(_vm.getAnalyteNames(_vm.testPackageSample.getTestPackageAnalytes()))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }